import React from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

export function Boolean(props) {
  const { value } = props;
  return (
    <div className={`${styles.text} ellipsis`}>{value ? "Yes" : "No"}</div>
  );
}

Boolean.propTypes = {
  value: PropTypes.bool
};
